import { makeAutoObservable } from "mobx";
import {
  isResourceType,
  ResourceTypeEnum,
} from "../../../Enums/ResourceTypeEnum";
import { isResourceIdResponseDTO } from "./ResourceId";

export interface ResourceIdAndNameResponseApi {
  resourceId: string;
  resourceName: string;
}

export let isResourceIdAndNameResponseDTO = (
  variable: unknown
): variable is ResourceResponseApi => {
  return (
    isResourceIdResponseDTO(variable) &&
    "resourceName" in variable &&
    typeof variable.resourceName === "string"
  );
};

export interface ResourceResponseApi {
  resourceId: string;
  resourceName: string;
  resourceVisibility: boolean;
  resourceTypeId: ResourceTypeEnum;
  resourceCost: number;
}

export let isResourceResponseDTO = (
  variable: unknown
): variable is ResourceResponseApi => {
  return (
    isResourceIdResponseDTO(variable) &&
    "resourceName" in variable &&
    typeof variable.resourceName === "string" &&
    "resourceVisibility" in variable &&
    typeof variable.resourceVisibility === "boolean" &&
    "resourceTypeId" in variable &&
    isResourceType(variable.resourceTypeId) &&
    "resourceCost" in variable &&
    typeof variable.resourceCost === "number"
  );
};

export class EmptyResourceResponseImpl implements ResourceResponseApi {
  resourceId: string = "";
  resourceName: string = "";
  resourceVisibility: boolean = false;
  resourceTypeId: number = -1;
  resourceCost: number = 0;
}

export class ObservableResourcePropImpl implements ResourceResponseApi {
  resourceId: string;
  resourceName: string;
  resourceVisibility: boolean;
  resourceTypeId: ResourceTypeEnum;
  resourceCost: number;

  constructor(resource: ResourceResponseApi) {
    this.resourceId = resource.resourceId;
    this.resourceName = resource.resourceName;
    this.resourceVisibility = resource.resourceVisibility;
    this.resourceTypeId = resource.resourceTypeId;
    this.resourceCost = resource.resourceCost;
    makeAutoObservable(this);
  }

  onChangeId = (resourceId: string) => {
    this.resourceId = resourceId;
  };

  onChangeName = (resourceName: string) => {
    this.resourceName = resourceName;
  };

  onChangeVisibility = (resourceVisibility: boolean) => {
    this.resourceVisibility = resourceVisibility;
  };

  onChangeType = (resourceTypeId: number) => {
    this.resourceTypeId = resourceTypeId;
  };

  onChangeCost = (resourceCost: number) => {
    this.resourceCost = resourceCost;
  };
}
